import React, { HTMLProps } from 'react';
import classNames from 'classnames';

const AttachmentProperty: React.FC<HTMLProps<HTMLSpanElement>> = ({ className, ...rest }) => (
    <span className={classNames('nhsuk-attachment__attribute', className)} {...rest} />
);

export default AttachmentProperty;